import { lang } from '@umu/ukit-lang';
import React, { useEffect, useLayoutEffect, useRef } from 'react';

import * as UA from '@umu/umu-ua';
import { initHeader } from '@umu/umu-common-header';
import { API_TYPE, IUserInfo } from '@umu/umu-types';

import { components } from 'common';
const { Logo } = components;
import { bizUtils } from 'businessCommon';
const { checkLogin, isEnterprise } = bizUtils;

import { initMarketCommonHeader, replaceLogo, initMarketSimpleHeader, CourseType } from './service';
import { isEnterpriseAdmin } from 'market/@marketCommon/utils/accountUtil';
import { $window } from '@umu/umu-dom';
import { render as renderHeader, IHeaderConfig } from '@umu/home-header';
import './marketHeader.scss';
import { getLangSwitchList } from '@umu/umu-lang-switch';
import { fetchData } from '@umu/umu-fetch';

interface IProps {
    userInfo: IUserInfo;
    siteHost: string;
    lang: string;
    system: string;
    course_type?: number;
}

const isFullIE = UA.isFullIE;

export const MarketHeader = (props: IProps) => {
    const { userInfo, lang: localeLang, system, siteHost, course_type = CourseType.Normal } = props;
    const isLogin = checkLogin(userInfo);

    const isLoginOrNotIE = isLogin || !isFullIE;
    const mobileHeaderRef = useRef<HTMLDivElement>(null);

    useLayoutEffect(() => {
        let title = '';
        if (course_type === CourseType.Tsinghua) {
            title = lang('清华大学经济管理学院在线证书项目');
        }
        if (course_type === CourseType.Mercer) {
            title = lang('美世在线学习解决方案');
        }
        if (!isLogin) {
            $window.setTimeout(() => {
                initMarketSimpleHeader(course_type, title);
            }, 500);
        }
        if (isLoginOrNotIE) {
            replaceLogo(userInfo);
            initHeader({
                lang: localeLang,
                system,
                userInfo,
                siteHost,
            });
            initMarketCommonHeader(
                isEnterpriseAdmin(userInfo),
                course_type,
                isEnterprise(userInfo.enterprise_id),
                title,
            );
        }
    }, []);

    const getMenuData = async function () {
        return await fetchData({
            type: API_TYPE.GET,
            url: '/napi/v1/home/config',
        }).then((res: any) => {
            return res.data;
        });
    };

    const getLangOptions = () => {
        const langOptions = getLangSwitchList();
        const newLangOptions = langOptions.map((item) => {
            return {
                val: item.key,
                text: item.value,
            };
        });
        return newLangOptions;
    };

    useEffect(() => {
        getMenuData().then((res: any) => {
            // 在header中移除 [ 课程市场 ] 的模块
            const headerData = res.header;
            // headerData.navMenu.navList = headerData.navMenu.navList.filter((item: any) => {
            //     return !['课程市场', 'Marketplace'].includes(item.title);
            // });

            const config = {
                siteHost: siteHost,
                platform: 'twww',
                system: system.toLocaleUpperCase(),
                headerData,
                langOptions: getLangOptions(),
                userInfo,
                isLogin: Boolean(userInfo.umu_id),
                lang: window.langMap[localeLang as 'zh-cn'],
            };
            try {
                renderHeader(config as IHeaderConfig, mobileHeaderRef.current as HTMLDivElement);
            } catch (e) {
                console.error(e);
            }
        });
    }, []);

    if (isLoginOrNotIE) {
        return <div className="ie-market-page-header-mobile" ref={mobileHeaderRef}></div>;
    }

    return (
        <>
            <div className="ie-market-page-header">
                <div className="page-header-wrap">
                    <div className="logo">
                        <div className="page-header-logo">
                            <Logo />
                            <a href="/index" className="btn trackEvent">
                                {lang('返回首页')}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
